import { render, staticRenderFns } from "./Prices.vue?vue&type=template&id=42168dd5"
import script from "./Prices.js?vue&type=script&lang=js&external"
export * from "./Prices.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports